import { Grid, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import CounterInput from "./CounterInput";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import SlideUpTransition from "../fundamentals/SlideUpTransition";
import { copyJsonObject } from "../../util/commonUtils";
import { isAwardedBid } from "../../util/bid/bidCommon.js";
import { getDayOfTheWeek, getFormattedMonthAndDate, getMinimumAllotmentValue } from "../../util/bid/IAMDATBidUtils";
import { isEqual } from "lodash";

const useStyles = makeStyles((theme) => ({
  counteStyle: {
    display: "flex",
    justifyContent: "space-around",
    fontSize: "28px",
    fontWeight: "bold",
  },
  dialogStyle: {
    width: "600px",
    margin: "auto",
    height: "425px",
  },
}));
const IAMDATAllotmentDialog = (props) => {
  const classes = useStyles();
  const [amOrPmCount, setAmOrPmCount] = useState(null);
  useEffect(() => {
    const selectedDayState = props?.allotmentDayState?.find((dayState) => dayState?.date === props?.date);
    setAmOrPmCount(selectedDayState?.amOrPmCount);
    // eslint-disable-next-line
  }, [props.allotmentDayState, props.date]);

  const handleCancelButtonClick = () => {
    const existingDayState = props.allotmentDayState.find((dayState) => dayState.date === props.date);
    const newDayState = {
      ...existingDayState,
      date: props.date,
      amOrPmCount: amOrPmCount,
    };
    if (!isEqual(existingDayState, newDayState)) {
      const copiedAllotmentDayState = copyJsonObject(props.allotmentDayState);
      const updatedAllotmentDayState = copiedAllotmentDayState.map((dayState) =>
        dayState.date === props.date ? newDayState : dayState
      );
      props.setAllotmentDayState(updatedAllotmentDayState);
    }
    props.setIsAllotmentDialogOpen(false);
  };

  return (
    <Dialog
      className={classes.dialogStyle}
      fullWidth
      open={props.isAllotmentDialogOpen}
      TransitionComponent={SlideUpTransition}
      keepMounted
      onClose={handleCancelButtonClick}
      data-testid="iam-dat-allotment-dialog"
    >
      <DialogContent sx={{ padding: "10px" }}>
        <Grid container justifyContent={"flex-end"}>
          <CloseIcon onClick={handleCancelButtonClick} sx={{ cursor: "pointer", padding: "2px" }} />
        </Grid>
        <Box
          sx={{
            border: "solid 0.5px",
            borderColor: "secondary.swaGray4",
            marginTop: "10px",
          }}
        >
          {props.date ? (
            <div>
              <Grid
                container
                spacing={1}
                justifyContent={"flex-end"}
                sx={{ paddingRight: "5px", fontSize: "24px", fontWeight: "bold" }}
              >
                <Grid item>{getDayOfTheWeek(props.date)}</Grid>
                <Grid item sx={{ color: "primary.swaBlue" }}>
                  {getFormattedMonthAndDate(props.date)}
                </Grid>
              </Grid>
              {amOrPmCount >= 0 && (
                <Grid
                  container
                  sx={{
                    textAlign: "center",
                    justifyContent: "space-around",
                    fontSize: "28px",
                    fontWeight: "bold",
                    padding: "35px",
                  }}
                >
                  <CounterInput
                    title="AM OR PM"
                    count={amOrPmCount}
                    setCount={setAmOrPmCount}
                    minValue={getMinimumAllotmentValue(
                      props.schedMonth,
                      props.schedYear,
                      props.date,
                      props.calcDailyAllotments
                    )}
                    disabled={isAwardedBid(props.bid.status)}
                  />
                </Grid>
              )}
            </div>
          ) : (
            <></>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

IAMDATAllotmentDialog.propTypes = {
  date: PropTypes.string.isRequired,
  allotmentDayState: PropTypes.array.isRequired,
  isAllotmentDialogOpen: PropTypes.bool.isRequired,
  setAllotmentDayState: PropTypes.func.isRequired,
  bid: PropTypes.object.isRequired,
  calcDailyAllotments: PropTypes.object.isRequired,
  schedMonth: PropTypes.string.isRequired,
  schedYear: PropTypes.string.isRequired,
};

export default IAMDATAllotmentDialog;
